export default __webpack_public_path__ + "static/4,2mm_lense_8015-6014-6e5eb99067319832639a0e525bf98796.webp";